/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Price,
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
    RouteCostsDetailsCountrySegment,
    RouteCostsDetailsCountrySegmentFromJSON,
    RouteCostsDetailsCountrySegmentFromJSONTyped,
    RouteCostsDetailsCountrySegmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface RouteCostsDetailsCountry
 */
export interface RouteCostsDetailsCountry {
    /**
     * 
     * @type {Price}
     * @memberof RouteCostsDetailsCountry
     */
    price: Price;
    /**
     * 
     * @type {number}
     * @memberof RouteCostsDetailsCountry
     */
    tollDistance?: number;
    /**
     * 
     * @type {string}
     * @memberof RouteCostsDetailsCountry
     */
    countryCode: string;
    /**
     * 
     * @type {Array<RouteCostsDetailsCountrySegment>}
     * @memberof RouteCostsDetailsCountry
     */
    segments?: Array<RouteCostsDetailsCountrySegment>;
}

export function RouteCostsDetailsCountryFromJSON(json: any): RouteCostsDetailsCountry {
    return RouteCostsDetailsCountryFromJSONTyped(json, false);
}

export function RouteCostsDetailsCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteCostsDetailsCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': PriceFromJSON(json['price']),
        'tollDistance': !exists(json, 'toll_distance') ? undefined : json['toll_distance'],
        'countryCode': json['country_code'],
        'segments': !exists(json, 'segments') ? undefined : ((json['segments'] as Array<any>).map(RouteCostsDetailsCountrySegmentFromJSON)),
    };
}

export function RouteCostsDetailsCountryToJSON(value?: RouteCostsDetailsCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': PriceToJSON(value.price),
        'toll_distance': value.tollDistance,
        'country_code': value.countryCode,
        'segments': value.segments === undefined ? undefined : ((value.segments as Array<any>).map(RouteCostsDetailsCountrySegmentToJSON)),
    };
}


